import _ from 'lodash'
import { useConcept } from '../../../redux/selectConcept'

interface L4TitleNodeProps {
	cid?: string
}

const L4TitleNode = ({cid}: L4TitleNodeProps) => {
	const concept = useConcept(cid)
	return <>{concept?.title || ''}</>
}

export default L4TitleNode
